// Barthel Index 用API の定数.
export const LOADING: string = 'BARTHEL INDEX_LOADING';
export const SUCCESS: string = 'BARTHEL_INDEX_SUCCESS';
export const ERROR: string = 'BARTHEL_INDEX_ERROR';
export const INITIALIZE: string = 'BARTHEL INDEX_INITIALIZE';

// BIの1日のデータの型.
export interface BarthelIndexData {
  // Unique ID
  unique_id?: string;
  // 食事.
  feeding?: string;
  // 車椅子からベッドへの移動.
  transfers?: string;
  // 整容.
  grooming?: string;
  // トイレ動作.
  toilet_use?: string;
  // 入浴.
  bathing?: string;
  // 階段昇降.
  stairs?: string;
  // 排便コントロール.
  bowels?: string;
  // 排尿コントロール.
  bladder?: string;
  // 歩行.
  mobility?: string;
  // 着替え.
  dressing?: string;
  // データ作成時間.
  created_at?: string;
  // データ更新時間.
  updated_at?: string;
  // 記録日.
  record_time?: string;
}

export interface LineGraphData {
  date: string; // '2020-4-12'
  count: number; // 40
}


// WEBPACK FOOTER //
// ./src/constants/BarthelIndexAPI.tsx